// Content Security Policy and Turbolinks' page cache (security audit SEC-13).
//
// Browsers hide a script's nonce attribute once the page has loaded, so the
// copy of a page Turbolinks keeps (shown on Back, and as a preview when a page
// is visited again) holds its inline scripts, e.g. Chartkick charts, with an
// empty nonce, and the CSP blocks them when Turbolinks runs them again. The
// nonce is the same for the whole session (content_security_policy.rb), so
// give back the current one, from the csp-nonce meta tag, to the scripts that
// had one. Scripts that never had a nonce stay blocked.
document.addEventListener("turbolinks:before-render", (event) => {
  const meta = document.querySelector("meta[name='csp-nonce']")
  if (!meta || !meta.content) return

  event.data.newBody.querySelectorAll("script[nonce]").forEach((script) => {
    script.setAttribute("nonce", meta.content)
  })
})
